import { BrandType } from '../enums/brandType';
import { PhaseContract } from '../enums/phaseContract.enum';
import { TypeContract } from '../enums/typeContract.enum';
import { TypeRequest } from '../enums/typeRequest.enum';

export interface ITableContractModelMeta {
    isEditable: boolean;
    isDeletable: boolean;
}

export class TableContractModelMeta implements ITableContractModelMeta {
    isDeletable: boolean;
    isEditable: boolean;
    constructor(meta: ITableContractModelMeta) {
        if (meta == null) {
            meta = {} as ITableContractModelMeta;
        }
        this.isDeletable = meta.isDeletable;
        this.isEditable = meta.isEditable;
    }
}

export interface ITableContractModel {
    id: number;
    brand: BrandType;
    createdAt: Date;
    customerFullName: string;
    phase: PhaseContract;
    agencyFullName: string;
    agentFullName: string;
    contractType: TypeContract;
    requestType: TypeRequest;
    city: string;
    podNumber: number;
    pdrNumber: number;
    meta: ITableContractModelMeta;
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/interfaces/tableContractModel.ts